"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgDonateFilled = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 8c0 .85-.177 1.659-.495 2.391A6.772 6.772 0 0 1 22 16.77 4.23 4.23 0 0 1 17.77 21h-4.181l-.6.594a1.408 1.408 0 0 1-1.978 0l-.6-.594h-4.18A4.23 4.23 0 0 1 2 16.77a6.772 6.772 0 0 1 4.495-6.379A6 6 0 1 1 18 8Zm-6 4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm.784 3.377a1.31 1.31 0 0 1 .92-.377c.35 0 .68.137.922.377.241.238.374.559.374.89 0 .33-.133.65-.373.89L12 19.758l-2.627-2.603a1.247 1.247 0 0 1 0-1.779 1.315 1.315 0 0 1 1.844 0l.783.776.784-.776Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgDonateFilled);
//# sourceMappingURL=SvgDonateFilled.js.map